<template>
  <div>
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <div class="row">
            <div class="col d-flex align-items-center">
              <div>
                <h6 class="header-pretitle">Overview</h6>
                <h1 class="header-title">Users</h1>
              </div>
            </div>

            <div class="col-auto d-flex align-items-center">
              <router-link :to="{ name: 'users.create' }" class="btn btn-sm btn-outline-primary">
                <font-awesome class="mr-2" :icon="['far', 'plus']"/> Add User
              </router-link>
            </div>
          </div><!-- /.row -->
        </div> <!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <div class="container-fluid container-boxed">
      <h3>Filter</h3>

      <div class="row">
          <div class="col-12 col-sm-12 col-lg-12 col-xl-4">
            <div class="form-group">
              <label class="control-label">Keyword</label>
              <input type="text" v-model="filters.search" class="form-control" placeholder="Name / Email / GEN" />
            </div><!-- /.form-group -->
          </div>

          <div class="col-12 col-sm-6 col-lg-6 col-xl-4">
            <div class="form-group">
              <label class="control-label">Type</label>
              <multiselect
                v-model="roleSelected"
                label="text"
                :options="roleOptions"
                :allow-empty="false"
                :searchable="false"
                :show-labels="false"/>
            </div><!-- /.form-group -->
          </div>

          <div class="col-12 col-sm-6 col-lg-6 col-xl-4">
              <div class="form-group">
                <label class="control-label">Status</label>
                <multiselect
                v-model="statusSelected"
                label="text"
                :options="statusOptions"
                :allow-empty="false"
                :searchable="false"
                :show-labels="false"/>
            </div><!-- /.form-group -->
          </div>
      </div><!-- /.row -->

      <div class="decorative-divider mt-0"></div>

      <div class="card">
        <loading-spinner v-if="fetching"/>

        <no-results v-else-if="haveNoUsers">
          No users found.
        </no-results>

        <ul v-else class="list-data">
          <li class="data-heading d-none d-xl-block">
            <div class="row">
              <div class="col-xl-5">
                Name
              </div>

              <div class="col-xl-2">
                GEN
              </div>

              <div class="col-xl-3">
                Type
              </div>

              <div class="col-xl-2">
                Status
              </div>
            </div><!-- /.row -->
          </li>

          <users-list-item v-for="user in users" :user="user" :key="user.id"/>
        </ul><!-- /.list-data -->

        <lazy-loading
          :loading="$loading"
          :reached-bottom="handleGetNextUsersCallback"
          ref="lazy">
          <loading-spinner slot="loading"/>
          <span slot="finished"></span>
        </lazy-loading>
      </div><!-- /.card -->
    </div><!-- /.container-fluid -->
  </div>
</template>

<script>
import { userComputed, userMethods } from 'vx/helpers'
import { appliesFilters } from 'mixins'
import UsersListItem from './UsersListItem'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [appliesFilters],

  components: {
    UsersListItem,
    Multiselect
  },

  data () {
    return {
      fetching: false,
      filters: {
        role: 'all',
        search: null,
        status: 'all'
      },
      roleOptions: [
        {
          value: 'all',
          text: 'All'
        },
        {
          value: 'graduate',
          text: 'Graduate'
        },
        {
          value: 'manager',
          text: 'Manager'
        },
        {
          value: 'coordinator',
          text: 'Agency Coordinator'
        },
        {
          value: 'admin',
          text: 'Admin'
        }
      ],
      statusOptions: [
        {
          value: 'all',
          text: 'Show All'
        },
        {
          value: 'enabled',
          text: 'Enabled'
        },
        {
          value: 'disabled',
          text: 'Disabled'
        }
      ]
    }
  },

  computed: {
    ...userComputed,

    haveNoUsers () {
      return this.users.length === 0
    },

    roleSelected: {
      get () {
        return this.roleOptions.find(option => option.value === this.filters.role)
      },

      set (option) {
        this.filters.role = option.value
      }
    },

    statusSelected: {
      get () {
        return this.statusOptions.find(option => option.value === this.filters.status)
      },

      set (option) {
        this.filters.status = option.value
      }
    }
  },

  watch: {
    queryParams: {
      async handler (params) {
        this.fetching = true

        await this.getUsers(params)

        this.fetching = false

        this.$nextTick(() => {
          if (this.$refs.lazy) {
            this.$refs.lazy.$emit('reset')
          }
        })
      },
      immediate: true
    }
  },

  methods: {
    ...userMethods,

    async handleGetNextUsersCallback () {
      await this.getUsersForNextPage(this.queryParams)

      this.$refs.lazy.$emit('reset')
    }
  }
}
</script>
